define([
  "underscore",
  "backbone",
  "i18n/i18n",
  "utils/error-modal-handler",
  "utils/alert-modal-handler"
  ], function(
    _,
    Backbone,
    i18n,
    ErrorModalHandler
  ) {

  var DEFAULT_LOGGEDIN_PATH = "apps/client/loggedin.html";
  var LOGIN_WINDOW_FEATURES = "menubar=no,width=800,height=600,top=100,left=100";
  var LOGIN_WINDOW_NAME = "_blank";

  var LoginWindowHandler = function() {
    // For each service contains, login window object and request queue
    var serviceRequestsQueue = {};
    var loginWindowIntervals = {};
    var errorModalHandler = new ErrorModalHandler(i18n('error_login_failed'));

    function openLoginWindow(callback, url, serviceURL, channelOptions) {
      var currentOpenWindowService = getCurrentOpenLoginWindowService();

      if (currentOpenWindowService) { // A window already open
        // Update a retryRequest callback for a URL with the most recent request
        addRequestToQueue(url, serviceURL, callback);
        currentOpenWindowService.loginWindow && currentOpenWindowService.loginWindow.focus();
      } else {
        var windowFeatures = LOGIN_WINDOW_FEATURES;
        var windowName = LOGIN_WINDOW_NAME;

        if (channelOptions && channelOptions.crossDomainAjax) {
          if (channelOptions.crossDomainAjax.loginWindowFeatures) {
            windowFeatures = channelOptions.crossDomainAjax.loginWindowFeatures;
          }

          if (channelOptions.crossDomainAjax.loginWindowName) {
            windowName = channelOptions.crossDomainAjax.loginWindowName;
          }
        }

        var loginHandlerFullURL = getLoginHandlerFullURL(serviceURL, channelOptions);
        var openLoginPageWindow = window.open(loginHandlerFullURL, windowName, windowFeatures);

        if (isPopupBlockerActivated(openLoginPageWindow)) {
          serviceRequestsQueue[serviceURL].windowCompleted = true;
          showPopupWindowBlockedAlert(
            loginHandlerFullURL,
            serviceURL,
            channelOptions,
            {
              url: url,
              retryCallback: callback
            });
          openNextServiceLoginWindow();
          return;
        }

        addRequestToQueue(url, serviceURL, callback);
        serviceRequestsQueue[serviceURL].loginWindow = openLoginPageWindow;
        serviceRequestsQueue[serviceURL].windowCompleted = false;
        setWindowInterval(serviceURL);
      }
    }

    function getLoginHandlerFullURL(serviceURL, channelOptions) {
      var loggedinPath = DEFAULT_LOGGEDIN_PATH;

      if (channelOptions && channelOptions.crossDomainAjax) {
        if (channelOptions.crossDomainAjax.loggedInHandlerBasePath) {
          loggedinPath = channelOptions.crossDomainAjax.loggedInHandlerBasePath;
          }
      }

      return serviceURL + "../../" + loggedinPath;
    }

    function setWindowInterval(serviceURL) {
      loginWindowIntervals[serviceURL] = setInterval(function() {
        var openLoginPageWindow = getServiceLoginWindow(serviceURL);
        if (openLoginPageWindow && openLoginPageWindow.closed) {
          clearInterval(loginWindowIntervals[serviceURL]);
          // Next request from same service
          retryNextServiceRequestInQueue(serviceURL);
          serviceRequestsQueue[serviceURL].windowCompleted = true;
          serviceRequestsQueue[serviceURL].loginWindow = null;
          openNextServiceLoginWindow();
        }
      }, 1000);
    }

    function getServiceLoginWindow(serviceURL) {
      return serviceRequestsQueue[serviceURL] ? serviceRequestsQueue[serviceURL].loginWindow : null;
    }

    function getCurrentOpenLoginWindowService() {
      var serviceURLs = _.keys(serviceRequestsQueue);
      var openWindow = false;
      if (serviceURLs.length) {
        var service;
        for (var i = 0; i < serviceURLs.length; i++) {
          service = serviceRequestsQueue[serviceURLs[i]];
          if (!service.windowCompleted && service.loginWindow) {
            openWindow = service;
            break;
          }
        }
      }

      return openWindow;
    }

    function showPopupWindowBlockedAlert(loginURL, serviceURL, options, retryObject, retryCount) {
      var hostname = new URL(serviceURL).hostname;
      var searchAppPath = substrInBetween(serviceURL, hostname, '/api/');

      // Display service url + search app path if set
      // If search-app.com/search/api/v2/ => search-app.com/search
      if (searchAppPath) {
        hostname += searchAppPath;
      }

      var message = i18n("error_login_failed_login_manualy", [
          hostname,
          "<a href='" + loginURL + "' target='_blank'>",
          "</a>"
        ]
      );
      var onRequestFailed = options &&
        options.application &&
        options.application.options &&
        options.application.options.onRequestFailed;
      
      // Application property crossDomainAjax.onLoginFailed, remove the following block after deprecation
      var onLoginFailed = getCorsOptionProperty(options, 'onLoginFailed');
      if (onLoginFailed) {
        console.warn('Application crossDomainAjax.onLoginFailed property is deprecated, please use the application onRequestFailed property instead');
        onLoginFailed('PopupBlocker', loginURL, serviceURL, {
            url: retryObject.url,
            retryRequestCallback: retryObject.retryCallback
          }
        )
        return;
      }
      // End deprecated

      var defaultHandler = function () {
        var errorAlertType = getCorsOptionProperty(options, 'onLoginFailedErrorComponent');
        if (errorAlertType === 'alertComponent') {
          addErrorAlert(serviceURL, options, message);
        } else {
          errorModalHandler.addError(message, hostname);
        }
      };

      if (onRequestFailed && _.isFunction(onRequestFailed)) {
        var errorState = { reason: 'PopupBlocker', retryCount: retryCount };
        var requestInfo = {
          requestUrl: retryObject.url,
          loginUrl: loginURL,
          serviceUrl: serviceURL
        };

        try {
          onRequestFailed(errorState, requestInfo, retryObject.retryCallback, defaultHandler);
        } catch (error) {
          console.warn('Unexpected error occurred inside "onRequestFailed" application property callback');
        }
      } else {
        defaultHandler();
      }
    }

    function addErrorAlert(serviceURL, options, message) {
      if (
        !options &&
        !options.application &&
        !options.application.channels &&
        !options.application.channels.alerts
      ) {
        return;
      }

      var alertID = "POPUPS_BLOCKED_" + serviceURL;
      var alertAlreadyDisplayed = options.application.channels.alerts.where({id: alertID}).length > 0;
      if (!alertAlreadyDisplayed) {
        var alertModel = new Backbone.Model({
          id: alertID,
          message: message,
          level: 'error'
        });

        options.application.channels.addAlert(alertModel);
      }
    }

    function getCorsOptionProperty(options, property) {
      return options &&
        options.crossDomainAjax &&
        options.crossDomainAjax[property]
    }

    function resetServiceLoginWindow(serviceURL, channelOptions) {
      if (!serviceRequestsQueue[serviceURL]) {
        serviceRequestsQueue[serviceURL] = {
          loginWindow: null,
          windowCompleted: false,
          serviceURL: serviceURL,
          requestQueue: {},
          channelOptions: channelOptions
        };
      }

      serviceRequestsQueue[serviceURL].windowCompleted = false;
    }

    function addRequestToQueue(url, serviceURL, callback) {
      serviceRequestsQueue[serviceURL].requestQueue[url] = {
        callback: callback,
        url: url
      };
    }

    function removeRequestFromQueue(url, serviceURL) {
      if (serviceRequestsQueue[serviceURL]) {
        delete serviceRequestsQueue[serviceURL].requestQueue[url];
      }
    }

    function retryNextServiceRequestInQueue(serviceURL) {
      setTimeout( function () {
        if (!serviceRequestsQueue[serviceURL]) {
          return;
        }
        var serviceRequestQueue = serviceRequestsQueue[serviceURL].requestQueue;
          var nextRequest = getObjectFirstElement(serviceRequestQueue);
          if (nextRequest) {
            if (nextRequest.callback) nextRequest.callback();
            removeRequestFromQueue(nextRequest.url, serviceURL);
          }
        }, 200);
    }

    function openNextServiceLoginWindow() {
      var serviceURLs = _.keys(serviceRequestsQueue);
      var nextServiceLoginWindow = null;
      for (var i = 0; i < serviceURLs.length; i++) {
        if (
          !serviceRequestsQueue[serviceURLs[i]].windowCompleted &&
          !serviceRequestsQueue[serviceURLs[i]].loginWindow
        ) {
          nextServiceLoginWindow = serviceRequestsQueue[serviceURLs[i]];
          break;
        }
      }

      if (nextServiceLoginWindow) {
        var firstRetryRequest = getObjectFirstElement(nextServiceLoginWindow.requestQueue);
        if (firstRetryRequest) {
          openLoginWindow(
            firstRetryRequest.callback,
            firstRetryRequest.url,
            nextServiceLoginWindow.serviceURL,
            nextServiceLoginWindow.channelOptions
          )
        }
      }
    }

    function isPopupBlockerActivated(popupWindow) {
      if (popupWindow) {
        // Chrome might display a popup even it if popup windows are blocked
          if (/chrome/.test(navigator.userAgent.toLowerCase())) {
              try {
                  popupWindow.focus();
              } catch (e) {
                  return true;
              }
          } else {
              popupWindow.onload = function() {
                  return (popupWindow.innerHeight > 0) === false;
              };
          }
      } else {
          return true;
      }
      return false;
    }

    function getObjectFirstElement(obj) {
      var objectKeys = _.keys(obj);

      return objectKeys.length ? obj[objectKeys[0]]: null;
    }

    function substrInBetween(wholeStr, str1, str2){
      if (_.indexOf(wholeStr, str1) === -1 || _.indexOf(wholeStr, str2) === -1) {
        return undefined;
      }
      var strlength1 = str1.length;
      return wholeStr.substring(
        _.indexOf(wholeStr, str1) + strlength1,
        _.indexOf(wholeStr, str2)
      );
    }

    return {
      openLoginWindow: openLoginWindow,
      resetServiceLoginWindow: resetServiceLoginWindow,
      retryNextServiceRequestInQueue: retryNextServiceRequestInQueue,
      getLoginHandlerFullURL: getLoginHandlerFullURL
    }
  };

  return LoginWindowHandler;
});
